import { render, staticRenderFns } from "./card-email-sequence.vue?vue&type=template&id=d5079fd4&scoped=true"
import script from "./card-email-sequence.vue?vue&type=script&lang=js"
export * from "./card-email-sequence.vue?vue&type=script&lang=js"
import style0 from "./card-email-sequence.vue?vue&type=style&index=0&id=d5079fd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5079fd4",
  null
  
)

export default component.exports